export default {"src":"/_next/static/media/logo-new-mobile.3c586935.svg","height":18,"width":205,"blurWidth":0,"blurHeight":0};